<button mat-icon-button
[matMenuTriggerFor]="optionMoreMenu"
(click)="$event.stopPropagation();"
>
  <mat-icon
    data-cy="option-more-btn">
    more_vert
  </mat-icon>
</button>
<mat-menu #optionMoreMenu="matMenu" class="option-more-menu">
  <button
    mat-menu-item
    class="option-more-menu"
    data-cy="publish-menu-item"
    [disabled]="option.status !== 'draft'"
    (click)="option.status === 'draft' && openPublishConfirmationDialog()"
    *ngIf="canPublishOption"
  >
    Publish to portal
  </button>
  <button
    mat-menu-item
    class="option-more-menu"
    data-cy="remove-from-portal-menu-item"
    [disabled]="option.status !== 'optionToBorrower'"
    (click)="option.status === 'optionToBorrower' && openRemoveFromPortalDialog()"
    *ngIf="canPublishOption"
  >
    Remove from portal
  </button>
  <button
    mat-menu-item
    class="option-more-menu"
    data-cy="request-contract-menu-item"
    matTooltip="Creates a contract request from the offer. Only one contract request can be made per deal."
    [disabled]="hasContractRequest"
    (click)="requestContract()"
    *ngIf="canCreateContractRequest"
  >
    Request Contract
  </button>
  <button
    mat-menu-item
    class="option-more-menu"
    (click)="editOption()"
    *ngIf="canEditOption">
    Edit
  </button>
  <button
    mat-menu-item
    [disabled]="(option.status === 'accepted' || option.status === 'contractRequested')"
    class="option-more-menu"
    data-cy="disabled-delete-menu-item"
    *ngIf="canDeleteOption"
    (click)="confirmDelete()"
  >
    Delete
  </button>
</mat-menu>
